import { logo } from "../../assets";

const Logo = ({ width, height }) => {
  return (
    <>
      <img
        src={logo}
        alt="Website Logo"
        className={`rounded-full bg-cover h-${height}`}
        width={width}
      />
    </>
  );
};

export default Logo;
